import apiClient from './client'

/**
 * API client per la gestione dei prodotti.
 * 
 * Endpoints:
 * - /api/v1/prodotti/ - CRUD prodotti
 * - /api/v1/prodotti/categorie/ - CRUD categorie
 * - /api/v1/prodotti/fornitori/ - CRUD fornitori
 */

// =============================================================================
// CATEGORIE
// =============================================================================

/**
 * Ottiene la lista delle categorie.
 * @param {Object} params - Parametri di filtro (attiva, search)
 */
export const getCategorie = (params = {}) => {
  return apiClient.get('/prodotti/categorie/', { params })
}

/**
 * Ottiene le categorie attive (per dropdown).
 */
export const getCategorieAttive = () => {
  return apiClient.get('/prodotti/categorie/attive/')
}

/**
 * Ottiene il dettaglio di una categoria.
 * @param {number} id - ID categoria
 */
export const getCategoria = (id) => {
  return apiClient.get(`/prodotti/categorie/${id}/`)
}

/**
 * Crea una nuova categoria.
 * @param {Object} data - Dati categoria
 */
export const createCategoria = (data) => {
  return apiClient.post('/prodotti/categorie/', data)
}

/**
 * Aggiorna una categoria esistente.
 * @param {number} id - ID categoria
 * @param {Object} data - Dati da aggiornare
 */
export const updateCategoria = (id, data) => {
  return apiClient.patch(`/prodotti/categorie/${id}/`, data)
}

/**
 * Elimina una categoria.
 * @param {number} id - ID categoria
 */
export const deleteCategoria = (id) => {
  return apiClient.delete(`/prodotti/categorie/${id}/`)
}

// =============================================================================
// FORNITORI
// =============================================================================

/**
 * Ottiene la lista dei fornitori.
 * @param {Object} params - Parametri di filtro (attivo, search)
 */
export const getFornitori = (params = {}) => {
  return apiClient.get('/prodotti/fornitori/', { params })
}

/**
 * Ottiene i fornitori attivi (per dropdown).
 */
export const getFornitoriAttivi = () => {
  return apiClient.get('/prodotti/fornitori/attivi/')
}

/**
 * Ottiene il dettaglio di un fornitore.
 * @param {number} id - ID fornitore
 */
export const getFornitore = (id) => {
  return apiClient.get(`/prodotti/fornitori/${id}/`)
}

/**
 * Crea un nuovo fornitore.
 * @param {Object} data - Dati fornitore
 */
export const createFornitore = (data) => {
  return apiClient.post('/prodotti/fornitori/', data)
}

/**
 * Aggiorna un fornitore esistente.
 * @param {number} id - ID fornitore
 * @param {Object} data - Dati da aggiornare
 */
export const updateFornitore = (id, data) => {
  return apiClient.patch(`/prodotti/fornitori/${id}/`, data)
}

/**
 * Elimina un fornitore.
 * @param {number} id - ID fornitore
 */
export const deleteFornitore = (id) => {
  return apiClient.delete(`/prodotti/fornitori/${id}/`)
}

// =============================================================================
// PRODOTTI
// =============================================================================

/**
 * Ottiene la lista dei prodotti.
 * @param {Object} params - Parametri di filtro e paginazione
 */
export const getProdotti = (params = {}) => {
  return apiClient.get('/prodotti/', { params })
}

/**
 * Ottiene i prodotti attivi (per dropdown).
 */
export const getProdottiAttivi = () => {
  return apiClient.get('/prodotti/attivi/')
}

/**
 * Ottiene i prodotti raggruppati per categoria.
 */
export const getProdottiPerCategoria = () => {
  return apiClient.get('/prodotti/per_categoria/')
}

/**
 * Ottiene il dettaglio di un prodotto.
 * @param {number} id - ID prodotto
 */
export const getProdotto = (id) => {
  return apiClient.get(`/prodotti/${id}/`)
}

/**
 * Crea un nuovo prodotto.
 * @param {Object} data - Dati prodotto
 */
export const createProdotto = (data) => {
  return apiClient.post('/prodotti/', data)
}

/**
 * Aggiorna un prodotto esistente.
 * @param {number} id - ID prodotto
 * @param {Object} data - Dati da aggiornare
 */
export const updateProdotto = (id, data) => {
  return apiClient.patch(`/prodotti/${id}/`, data)
}

/**
 * Elimina un prodotto (soft delete).
 * @param {number} id - ID prodotto
 */
export const deleteProdotto = (id) => {
  return apiClient.delete(`/prodotti/${id}/`)
}

/**
 * Duplica un prodotto esistente.
 * @param {number} id - ID prodotto da duplicare
 * @param {string} nuovoCodice - Codice per il nuovo prodotto
 */
export const duplicaProdotto = (id, nuovoCodice) => {
  return apiClient.post(`/prodotti/${id}/duplica/`, { nuovo_codice: nuovoCodice })
}

export default {
  // Categorie
  getCategorie,
  getCategorieAttive,
  getCategoria,
  createCategoria,
  updateCategoria,
  deleteCategoria,
  // Fornitori
  getFornitori,
  getFornitoriAttivi,
  getFornitore,
  createFornitore,
  updateFornitore,
  deleteFornitore,
  // Prodotti
  getProdotti,
  getProdottiAttivi,
  getProdottiPerCategoria,
  getProdotto,
  createProdotto,
  updateProdotto,
  deleteProdotto,
  duplicaProdotto,
}
